import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { signInWithPopup, GoogleAuthProvider } from 'firebase/auth';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { auth, db } from '../firebase';
import SEO from '../components/SEO';
import { IconLock } from '../components/Icons';
import styles from './AdminLogin.module.css';

export default function AdminLogin() {
  const navigate = useNavigate();
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleGoogleLogin = async () => {
    setLoading(true);
    setError('');
    try {
      const provider = new GoogleAuthProvider();
      const result = await signInWithPopup(auth, provider);
      
      // Check if email is authorized in Firestore
      const adminsRef = collection(db, 'admins');
      const q = query(adminsRef, where('email', '==', result.user.email));
      const querySnapshot = await getDocs(q);
      
      if (!querySnapshot.empty) {
        navigate('/admin');
      } else {
        setError(`Unauthorized email: ${result.user.email}`);
        await auth.signOut();
      }
    } catch (err) {
      if (err.code === 'auth/popup-closed-by-user') {
        setError('Sign-in cancelled.');
      } else {
        setError('Google sign-in failed. Please try again.');
        console.error('Error:', err);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <SEO
        title="Admin Login | Keepers Experience"
        description="Admin panel login"
        noindex={true}
      />
      <div className={styles.page}>
      <div className={styles.bg} />
      <div className={styles.box}>
        <div className={styles.logoRow}>
          <img src="/keepers-logo.png" alt="Keepers Logo" className={styles.logoImg} />
        </div>
        <div className={styles.lockIcon}><IconLock size={26} /></div>
        <h1 className={styles.title}>Admin Panel</h1>
        <p className={styles.sub}>Sign in with your Google account to access the dashboard</p>

        {error && <p className={styles.error}>{error}</p>}

        <button 
          type="button" 
          className={styles.googleBtn}
          onClick={handleGoogleLogin}
          disabled={loading}
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
            <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
            <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
            <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
            <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
          </svg>
          {loading ? <span className={styles.spinner} /> : 'Sign in with Google'}
        </button>

        <button className={styles.backLink} onClick={() => navigate('/')}>
          ← Back to website
        </button>
      </div>
    </div>
    </>
  );
}
